import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbMap = {
    'homepage': { label: 'Inicio', labelEn: 'Home' },
    'services-catalog': { label: 'Servicios', labelEn: 'Services' },
    'project-gallery': { label: 'Galería', labelEn: 'Gallery' },
    'about-us': { label: 'Nosotros', labelEn: 'About Us' },
    'blog-resources': { label: 'Blog', labelEn: 'Blog' },
    'contact-quote-request': { label: 'Contacto', labelEn: 'Contact' },
  };

  if (pathnames.length === 0 || pathnames[0] === 'homepage') {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-text-secondary mb-6" aria-label="Breadcrumb">
      <Link
        to="/homepage"
        className="hover:text-primary nav-transition flex items-center"
      >
        <Icon name="Home" size={16} className="mr-1" />
        Inicio
      </Link>
      
      {pathnames.map((pathname, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const breadcrumbInfo = breadcrumbMap[pathname];
        
        if (!breadcrumbInfo) return null;

        return (
          <React.Fragment key={pathname}>
            <Icon name="ChevronRight" size={16} className="text-border" />
            {isLast ? (
              <span className="text-text-primary font-medium" aria-current="page">
                {breadcrumbInfo.label}
              </span>
            ) : (
              <Link
                to={routeTo}
                className="hover:text-primary nav-transition"
              >
                {breadcrumbInfo.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;